import { gql } from '@apollo/client';

const updateStartWork = gql`
  mutation updateStartWork(
    $_id: String
    $time: Date
    $title: String
    $desc: String
    $items: String
    $contract: ContractInput
    $department: DepartmentInput
    $employee: EmployeeInput
    $bonos: Float
    $overtime: Float
    $deduction: Float
    $isWorking: Int
    $isAbsent: Int
    $isShift1: Int
    $isShift2: Int
    $isVacation: Boolean
    $note: String
  ) {
    updateStartWork(
      _id: $_id
      time: $time
      title: $title
      desc: $desc
      items: $items
      contract: $contract
      department: $department
      employee: $employee
      bonos: $bonos
      overtime: $overtime
      deduction: $deduction
      isWorking: $isWorking
      isAbsent: $isAbsent
      isShift1: $isShift1
      isShift2: $isShift2
      isVacation: $isVacation
      note: $note
    ) {
      ok
      data {
        _id
        branch
        autoNo
        docNo
        time
        title
        desc
        contractId
        contractName
        contractNameAr
        departmentId
        departmentName
        departmentNameAr
        departmentColor
        employeeId
        employeeName
        employeeNameAr
        bonos
        overtime
        deduction
        isWorking
        isAbsent
        isShift1
        isShift2
        isVacation
        userId
        note
        createdAt
        updatedAt
      }
      message
      error
    }
  }
`;

export default updateStartWork;
